"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGExporter = void 0;
const color_1 = require("@urpflanze/color");
class SVGExporter {
    static parse(scene, settings = {}) {
        const bindedSettings = {
            ...SVGExporter.defaults,
            ...settings,
        };
        return SVGExporter.generate(scene, bindedSettings);
    }
    /**
     * Get drawer prop
     *
     * @param key name of the property (fill, stroke, lineWidth)
     * @param propArguments currentIndexing propArguments
     * @param defaultValue
     *
     * @returns string | number
     */
    static getSVGProp(key, propArguments, defaultValue) {
        let attribute = propArguments.shape.drawer[key];
        if (typeof attribute === 'function') {
            attribute = attribute(propArguments);
        }
        return attribute !== null && attribute !== void 0 ? attribute : defaultValue;
    }
    /**
     *
     * @param type fill | stroke
     * @param color string
     * @param attriburesPtr list of attributes to apply
     * @param stylePtr Array of string to put in style attr
     *
     * @returns
     */
    static bindColorAttribute(type, color, attriburesPtr, stylePtr) {
        if (typeof color === 'undefined')
            return;
        if (color === 'none') {
            attriburesPtr.push(`${type}="none"`);
        }
        else {
            const parsed = color_1.parseColorAndConvert(color);
            if (parsed) {
                if (parsed.alpha !== 1) {
                    stylePtr.push(`${type}-opacity: ${parsed.alpha}`);
                }
                attriburesPtr.push(`${type}="${color_1.rgbToHex(parsed.r, parsed.g, parsed.b)}"`);
            }
        }
    }
    /**
     * Generate SVG from scene and settings
     *
     * @param scene
     * @param settings
     * @returns
     */
    static generate(scene, settings) {
        const paths = SVGExporter.generatePaths(scene, settings);
        let background;
        if (settings.background) {
            const attributes = [];
            const styles = [];
            SVGExporter.bindColorAttribute('fill', scene.background, attributes, styles);
            styles.length > 0 && attributes.push(`styles="${styles.join('; ')}"`);
            background = `<rect width="${scene.width}" height="${scene.height}" ${attributes.length ? attributes.join(' ') + ' ' : ''}/>`;
        }
        return (`<svg viewBox="0 0 ${scene.width} ${scene.height}">` +
            `\n\t<!-- Create with Urpflanze <https://docs.urpflanze.org> -->` +
            (background ? `\n\t${background}` : '') +
            `\n\t${paths.join('\n\t')}` +
            `\n</svg>`);
    }
    /**
     * Convert shapes to paths
     *
     * @param scene
     * @param settings
     * @returns
     */
    static generatePaths(scene, settings) {
        const paths = [];
        const sceneChilds = scene.getChildren();
        for (let i = 0, len = sceneChilds.length; i < len; i++) {
            sceneChilds[i].generate(0, true);
            const childBuffer = sceneChilds[i].getBuffer() || [];
            const childIndexedBuffer = sceneChilds[i].getIndexedBuffer() || [];
            let childVertexIndex = 0;
            for (let currentBufferIndex = 0, len = childIndexedBuffer.length; currentBufferIndex < len; currentBufferIndex++) {
                const currentIndexing = childIndexedBuffer[currentBufferIndex];
                // Store points
                const points = [];
                for (let len = childVertexIndex + currentIndexing.frameLength; childVertexIndex < len; childVertexIndex += 2) {
                    points.push(childBuffer[childVertexIndex].toFixed(settings.decimals) +
                        ' ' +
                        childBuffer[childVertexIndex + 1].toFixed(settings.decimals));
                }
                // get styles and bind attributes
                const propArguments = {
                    shape: currentIndexing.shape,
                    repetition: currentIndexing.repetition,
                    parent: currentIndexing.parent,
                };
                const attributes = [];
                const styles = [];
                const fill = SVGExporter.getSVGProp('fill', propArguments);
                SVGExporter.bindColorAttribute('fill', fill || 'none', attributes, styles);
                const stroke = SVGExporter.getSVGProp('stroke', propArguments, typeof fill === 'undefined' ? scene.color : undefined);
                SVGExporter.bindColorAttribute('stroke', stroke, attributes, styles);
                const lineWidth = SVGExporter.getSVGProp('lineWidth', propArguments, 1);
                if (stroke)
                    attributes.push(`stroke-width="${lineWidth || 1}"`);
                // move style to attributes
                styles.length > 0 && attributes.push(`style="${styles.join('; ')}"`);
                // build path
                const d = `M${points.join(' L')} ${currentIndexing.shape.isClosed() ? 'Z' : ''}`;
                const path = `<path d="${d}" ${attributes.length ? attributes.join(' ') + ' ' : ''}/>`;
                paths.push(path);
            }
        }
        return paths;
    }
}
exports.SVGExporter = SVGExporter;
SVGExporter.defaults = {
    decimals: 3,
    background: true,
};
//# sourceMappingURL=SVGExporter.js.map